import owd from 'owd/owd';

export default class VideoAutoplayCase extends owd.Component {
  init() {
    const is_safari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
    const is_chrome_ios = !!navigator.userAgent.match('CriOS');
    const is_firefox_ios = !!navigator.userAgent.match('FxiOS');
    const is_ios = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);

    if (is_safari || is_chrome_ios || is_firefox_ios) {
      let $videoClone = this.$element.clone();
      let $iframe = $('<iframe>');

      if (is_ios) {
        $videoClone[0].muted = true;
      }

      $iframe.css({
            background: '#000',
            width: '100%',
            height: '100%',
            position : 'absolute',
            zIndex : '0'
      });

      this.$element.before($iframe);

      $iframe.ready(() => {
        $iframe.contents().find("body").append($videoClone);

        $iframe.contents().find("body").css({
          padding: 0,
          margin: 0,
          overflow: 'hidden',
          display: 'flex',
          alignItems: 'center',
          opacity: 1,
        });

        $iframe.contents().find("video").css({
          objectFit: 'cover',
          width: '100%',
          height: '100%'
        });

        this.on('ended', $iframe.contents().find("video"), () => {
          this.$element.trigger('iframe-ended');
        });

        this.on('should-pause', () => {
          if ($iframe.contents().find("video")[0] && $iframe.contents().find("video")[0].pause) {
            $iframe.contents().find("video")[0].pause();
          }
        });
      });

      // $iframe.attr('class', this.$element.attr('class'));
      $iframe.addClass('video-iframe-polyfill');

      if (this.$element[0] && this.$element[0].pause) {
        // this.$element[0].pause();
      }

      this.$iframe = $iframe;
    }
  }

  destroy() {
    super.destroy();
    // console.log(this.$iframe, this.$iframe.contents().find("video"));

    if (this.$iframe) {
      if (this.$iframe.contents().find("video")[0] && this.$iframe.contents().find("video")[0].pause) {
        this.$iframe.contents().find("video")[0].pause();
      }
      this.$iframe.attr('src', '');
    }
  }
}

owd.registerComponent('video-autoplay-case', {
  component: VideoAutoplayCase
});
